export default __webpack_public_path__ + "static/stork-477d254a5d5d068cd305fa9dc2c7965d.png";